import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteryDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_BATTERY: t('editBattery'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
